module.exports = __webpack_public_path__ + "static/media/por_wco.cefa8ff3.png";